/* eslint-disable jsdoc/valid-types */
// All screen views for the AccountLoginRegistration component
export const SCREENS = /** @type {const} */ ({
  REGISTER: 'register',
  LOGIN: 'login',
  SOCIAL_REGISTRATION: 'socialRegistration',
  LOGIN_OTC_EMAIL: 'loginOTCEmail',
  VERIFY_OTC: 'verifyOneTimeCode',
  LOGIN_OTC: 'loginWithOneTimeCode',
  USER_NAME: 'userName',
  REGISTRATION_SUCCESS: 'registrationSuccess',
  LOGIN_SUCCESS: 'loginSuccess',
  NBCU_PROFILE: 'nbcuProfile',
  SELECT_INTERESTS: 'selectInterests',
});

/** @typedef {SCREENS[keyof typeof SCREENS]} LoginFormScreen */

// Screens that display the background “circles” element
/** @type {LoginFormScreen[]} */
export const SCREENS_WITH_CIRCLES = [
  SCREENS.REGISTER,
  SCREENS.LOGIN,
];

// entry point screens
/** @type {LoginFormScreen[]} */
export const LOGIN_ENTRY_SCREENS = [
  SCREENS.LOGIN,
  SCREENS.REGISTER,
];

// screens that must NEVER show a back button
/** @type {LoginFormScreen[]} */
export const NO_BACK_SCREENS = [
  SCREENS.REGISTER,
  SCREENS.LOGIN,
  SCREENS.USER_NAME,
];

// success screens
/** @type {LoginFormScreen[]} */
export const SUCCESS_SCREENS = [
  SCREENS.LOGIN_SUCCESS,
  SCREENS.REGISTRATION_SUCCESS,
];

// treat these as post-auth
/** @type {LoginFormScreen[]} */
export const POST_LOGIN_SCREENS = [
  ...SUCCESS_SCREENS,
  SCREENS.USER_NAME,
];
